import { render, staticRenderFns } from "./ctrlobs.vue?vue&type=template&id=5250d030"
import script from "./ctrlobs.vue?vue&type=script&lang=js"
export * from "./ctrlobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports